/**
 * @generated SignedSource<<b69d3baeb7ee350d1116ebad2502c7e9>>
 * @relayHash 950b8a0cc917ee9957d120cc8771f025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3b9988016ae1c8ede35ba32fa87e46a2e2e60cdc7bf7896047cdc65e98cc9b1

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "commentId"
    },
    v2 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }, {
      "kind": "Variable",
      "name": "commentId",
      "variableName": "commentId"
    }, {
      "kind": "Literal",
      "name": "contentStatus",
      "value": ["CURRENT"]
    }, {
      "kind": "Literal",
      "name": "depth",
      "value": "ALL"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "parentId"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "container",
      "plural": false,
      "selections": [v4 /*: any*/, {
        "kind": "ScalarField",
        "name": "type"
      }]
    },
    v6 = {
      "kind": "ScalarField",
      "name": "isInlineComment"
    },
    v7 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "InlineCommentResolveProperties",
        "kind": "LinkedField",
        "name": "inlineResolveProperties",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "resolved"
        }]
      }],
      "type": "InlineComment"
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/],
      "kind": "Fragment",
      "name": "mainCommentDataQuery",
      "selections": [{
        "args": v2 /*: any*/,
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [{
          "concreteType": "CommentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [{
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "replies",
              "plural": true,
              "selections": [v3 /*: any*/]
            }, v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
              "kind": "LinkedField",
              "name": "location",
              "plural": false,
              "selections": [v7 /*: any*/]
            }]
          }]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1 /*: any*/, v0 /*: any*/],
      "kind": "Operation",
      "name": "mainCommentDataQuery",
      "selections": [{
        "args": v2 /*: any*/,
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [{
          "concreteType": "CommentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [{
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "replies",
              "plural": true,
              "selections": [v3 /*: any*/, v4 /*: any*/]
            }, v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
              "kind": "LinkedField",
              "name": "location",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "__typename"
              }, v7 /*: any*/]
            }, v4 /*: any*/]
          }]
        }]
      }]
    },
    "params": {
      "id": "d3b9988016ae1c8ede35ba32fa87e46a2e2e60cdc7bf7896047cdc65e98cc9b1",
      "metadata": {},
      "name": "mainCommentDataQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "51516d7b0d37fa94b2935d8d4858962e";
export default node;